// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__2tbm7","disabled":"Checkbox_disabled__AbY3f"};